<template>
  <!-- Figma 57554:80846: モーダル本体内 p-16。タグ風 3 行 (h-40) → hr (h-16) → 体験風 3 行 (h-88)。
       行間 gap なし、要素は #d9d9d9 のプレースホルダ矩形のみ -->
  <div aria-hidden="true" class="flex animate-pulse flex-col p-4">
    <div v-for="i in 3" :key="`t-${i}`" class="flex h-10 items-center gap-2 p-2">
      <div class="size-6 shrink-0 rounded-[2px] bg-[#d9d9d9]" />
      <div class="h-2 w-[97px] rounded-[2px] bg-[#d9d9d9]" />
    </div>

    <div class="h-4 w-full border-b-[0.5px] border-dashed border-beige3" />

    <div v-for="i in 3" :key="`e-${i}`" class="flex h-[88px] items-center gap-2 p-2">
      <div class="size-[72px] shrink-0 rounded-[2px] bg-[#d9d9d9]" />
      <div class="flex flex-col gap-2">
        <div class="h-2 w-[234px] rounded-[2px] bg-[#d9d9d9]" />
        <div class="h-2 w-[210px] rounded-[2px] bg-[#d9d9d9]" />
      </div>
    </div>
  </div>
</template>
